module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_26.5dc4c794.png";